export default class Hooks{
    constructor(){
        this.listeners={};
        this.dependency=[];
    }

    listen(eventname,callback){
        if(!eventname || !callback)return;

        if(callback instanceof Function)this.listeners[eventname]=callback;
    }

    dispatch(eventname,data=null){
        let callback= this.listeners[eventname];
        callback?.(data);
        //dispatch to sidehooks:
        this.dependency.forEach(sidehook=>{
            sidehook.dispatch?.(eventname,data);
        })
    }
   
    remove(eventname){
    
        eventname && ( this.listeners[eventname]=null );
        
    }
        
    attach(sidehook){
        
        if(sidehook instanceof Hooks)this.dependency.push(sidehook);
        
    }
        
    destroy(){
            this.listeners={};
            this.dependency=[];
    }
}


// let hooks=()=>{

//     let listeners={};
    
//     let dependency=[];
    
//     let listen=(identifier,callback)=>{
    
//         if(!identifier || !callback)return;
    
//         listeners[identifier]=callback;
    
//     }
    
//     let dispatch=(identifier,data=null)=>{
//         let callback= listeners[identifier];
//         if(callback && (callback instanceof Function))callback(data);
//         dependency.forEach(sidehook=>{
//             sidehook.dispatch?.(identifier,data);
//         })
//     }
    
//     let remove=(identifier)=>{
    
//     identifier && ( listeners[identifier]=null );
    
//     }
    
//     let attach=(sidehook)=>{
    
//     if(sidehook instanceof Object)dependency.push(sidehook);
    
//     }
    
//     let destroy=()=>{
//         listeners={};
//         dependency=[];
//     }
    
    
//     return {listen,dispatch,remove,destroy,attach}
    
    
//     }